import React from 'react';
import { cn } from '@/lib/utils';

export const DrunkCard = ({ 
  children, 
  variant = 'default',
  rotate = false,
  className,
  ...props 
}) => {
  const baseStyles = "border-2 border-black rounded-xl p-6";
  
  const variants = {
    default: "bg-white shadow-brutal-lg",
    pink: "bg-pink text-white shadow-brutal-lg",
    cyan: "bg-cyan text-black shadow-brutal-lg",
    yellow: "bg-yellow text-black shadow-brutal-lg",
    gradient: "bg-gradient-to-br from-pink to-cyan text-white shadow-brutal-lg"
  };

  const rotateStyle = rotate ? "rotate-1 hover:rotate-0 transition-transform" : "";

  return (
    <div
      className={cn(baseStyles, variants[variant], rotateStyle, className)}
      {...props}
    >
      {children}
    </div>
  );
};

export default DrunkCard;
